import { FeaturedIcon } from '@/lib';
import { TranslationKeys } from '@/localization';
import { toRuntimeTranslationKey } from '@/localization/translationKey';
import { t } from 'i18next';
import { FC, ReactNode } from 'react';

type ResetPasswordHeaderProps = {
  icon: ReactNode;
  title: TranslationKeys;
  subtitle: ReactNode;
};

export const ResetPasswordHeader: FC<ResetPasswordHeaderProps> = ({ icon, title, subtitle }) => {
  return (
    <header className='grid justify-items-center gap-8'>
      <FeaturedIcon type='modern' size='lg'>
        {icon}
      </FeaturedIcon>
      <div className='grid justify-items-center gap-3 text-center'>
        <h1 className='text-pretty text-3xl font-semibold text-primary-900'>{t(toRuntimeTranslationKey(title) as any)}</h1>
        <h2 className='text-tertiary-600'>{subtitle}</h2>
      </div>
    </header>
  );
};
